<template>
  <div>
    <h3>
      How to resolve this?
      <a
        v-if="showLink"
        class="link"
        href="https://headstart.infocusp.com/#/faq"
        target="_blank"
        >&#128279;</a
      >
    </h3>
  </div>
</template>
<script>
export default {
  name: 'FaqHeader',
  props: {
    showLink: {
      default: false,
      type: Boolean,
    },
  },
}
</script>
<style scoped>
h3 span:hover {
  cursor: pointer !important;
}
.link {
  text-decoration: none;
}
</style>
